import { StyleSheet } from 'aphrodite';
import { destructive } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	disconnected: {
		color: destructive,
		fontSize: 10,
		marginTop: -2,
	},
});
